import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {
  AppInitializerFacade,
  AppResponseWithStatus,
  HttpRequestStatus,
} from '@cpm-pr1618003/ng-initializer-lib';
import { Observable } from 'rxjs';

export const authGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const facade = inject(AppInitializerFacade);

  return new Promise((resolve, reject) => {
    facade.appResponse$.subscribe((value: AppResponseWithStatus) => {
      if (
        value &&
        (value.appInitializerRequestStatus === HttpRequestStatus.Success ||
          value.appInitializerRequestStatus === HttpRequestStatus.Failed)
      ) {
        if (value.isAppValid) {
          resolve(true);
        } else {
          resolve(false);
        }
      }
    });
  });
};
